import React, { useContext } from "react";
import { RESOURCE_NAME } from "common/authorization";
import { AuthContext } from "../../Authorization/AuthContext";
import { Box } from "../../Common/__styles__/Layout";
import { InsufficientPermissions } from "../../Common/InsufficientPermissions";
import { MenuItems, SubTabMenu } from "../SubTabMenu";
import BaseMaps from "./BaseMaps";
import DocumentTemplates from "./DocumentTemplates";
import { ElevationCertificates } from "./ElevationCertificates";
import Firms from "./FIRMs";
import HelpscoutSettings from "./Helpscout";
import { Integrations } from "./Integrations";
import { Accela } from "./Integrations/Accela";
import ArcGISExports from "./Integrations/ArcGISExports";
import Operations from "./Operations";
import Parcels from "./Parcels";
import Rasters from "./Rasters";
import RepetitiveLossData from "./RepetitiveLossImports";

export interface DataImportsMenuProps {
  canViewParcelsSubTab: boolean;
  canViewFirmsSubTab: boolean;
}

const InsufficientPermissionsWrapper = () => {
  return (
    <Box>
      <InsufficientPermissions />
    </Box>
  );
};

export const Data = () => {
  const { authorized } = useContext(AuthContext);

  const canViewParcelsSubTab = authorized({
    resource: RESOURCE_NAME.PARCEL_IMPORT_CONFIGURATION,
    permission: "view",
  });

  const canViewFirmsSubTab = authorized({
    resource: RESOURCE_NAME.FIRM,
    permission: "view_settings",
  });

  const canViewRepetitiveLossImportsSubTab = authorized({
    resource: RESOURCE_NAME.REPETITIVE_LOSS_IMPORT_JOB,
    permission: "list",
  });

  const menuItems: MenuItems = [
    {
      name: "Parcels",
      path: "/parcels",
      component:
        canViewParcelsSubTab ? Parcels : InsufficientPermissionsWrapper,
    },
    {
      name: "FIRMs",
      path: "/firms",
      component: canViewFirmsSubTab ? Firms : InsufficientPermissionsWrapper,
    },
    {
      name: "Templates",
      path: "/document-templates",
      component: DocumentTemplates,
    },
    {
      name: "Elevation Certificates",
      path: "/elevation-certificates",
      component: ElevationCertificates,
    },
    {
      name: "Base maps",
      path: "/base-maps",
      component: BaseMaps,
    },
    {
      name: "Rasters",
      path: "/rasters",
      component: Rasters,
    },
    {
      name: "ArcGIS",
      path: "/integrations/arcgis",
      component: ArcGISExports,
      hide: true,
    },
    {
      name: "Accela",
      path: "/integrations/accela",
      component: Accela,
      hide: true,
    },
    // Integrations must be below the integration type urls
    {
      name: "Integrations",
      path: "/integrations",
      component: Integrations,
    },

    {
      name: "Helpscout",
      path: "/helpscout",
      component: HelpscoutSettings,
    },
    {
      name: "Operations",
      path: "/operations",
      component: Operations,
    },
  ];

  if (canViewRepetitiveLossImportsSubTab) {
    menuItems.splice(2, 0, {
      name: "Repetitive loss",
      path: "/repetitive-loss",
      component: RepetitiveLossData,
    });
  }

  return <SubTabMenu menuItems={menuItems} />;
};
